import React from "react";

const Button = ({ value, isActive }) => {
	return (
		<div
			className='w-5 h-5 text-sm rounded-full flex items-center justify-center mr-2'
			style={{
				borderColor: isActive ? "#3056D3" : "#64748B",
				borderWidth: "1px",
				color: isActive ? "#3056D3" : "#64748B",
				background: "#FFF",
				fontWeight: 400,
				marginRight: "16px",
			}}>
			{value}
		</div>
	);
};

export default Button;
